import { render, staticRenderFns } from "./DocLayout.vue?vue&type=template&id=03b1e550&"
import script from "./DocLayout.vue?vue&type=script&lang=js&"
export * from "./DocLayout.vue?vue&type=script&lang=js&"
import style0 from "./DocLayout.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports